import gql from 'graphql-tag';

import { MediaFragment } from '../fragments';

export default gql`
  ${MediaFragment}

  query mediaOnChannelQuery(
    $channelId: UUID!
    $search: MediaSearch
    $tags: StringListSearch
    $path: Path
    $pagination: PaginationInput
    $mediaTypes: [MediaType]
  ) {
    mediaOnChannel(
      channelId: $channelId
      search: $search
      tags: $tags
      path: $path
      pagination: $pagination
      mediaTypes: $mediaTypes
    ) {
      pageInfo {
        start
        total
        perPage
      }
      items {
        _id
        tags
        path
        media {
          ...MediaFragment
        }
      }
    }
  }
`;
